export { default } from "./Label";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/internal/Label/index.js
// module id = 920
// module chunks = 17